import {
  IsNotEmpty,
  Matches,
  MaxLength,
  IsEmail,
  ValidateIf,
} from "class-validator";

export class LegalStep1Dto {
  @IsNotEmpty({ message: "Укажите сокращённое наименование" })
  legalName: string = "";

  @IsNotEmpty({ message: "Укажите полное наименование" })
  legalFullName: string = "";

  @IsNotEmpty({ message: "Укажите ИНН" })
  @Matches(/^\d{10}$|^\d{12}$/, { message: "ИНН: 10 или 12 цифр" })
  inn: string = "";

  @IsNotEmpty({ message: "Укажите ОГРН" })
  @Matches(/^\d{13}$|^\d{15}$/, { message: "ОГРН: 13 или 15 цифр" })
  ogrn: string = "";

  orgForm: string = "";

  @ValidateIf((o) => o.orgForm !== "ИП")
  @IsNotEmpty({ message: "Укажите КПП" })
  @Matches(/^\d{9}$/, { message: "КПП: 9 цифр" })
  kpp: string = "";

  @IsNotEmpty({ message: "Укажите billing descriptor" })
  @MaxLength(14, { message: "Макс. 14 символов" })
  @Matches(/^[A-Za-z0-9\s.\-*]+$/, {
    message: "Только латиница, цифры, пробелы, дефисы",
  })
  billingDescriptor: string = "";

  @ValidateIf((o) => !!o.legalEmail?.trim())
  @IsEmail({}, { message: "Некорректный email" })
  legalEmail: string = "";

  @ValidateIf((o) => !!o.siteUrl?.trim())
  @Matches(/^https?:\/\/.+/, {
    message: "URL должен начинаться с http:// или https://",
  })
  siteUrl: string = "";
}

export class LegalStep2Dto {
  @IsNotEmpty({ message: "Укажите город" })
  city: string = "";

  @IsNotEmpty({ message: "Укажите улицу" })
  street: string = "";

  @IsNotEmpty({ message: "Укажите дом" })
  building: string = "";

  @ValidateIf((o) => !!o.postalCode?.trim())
  @Matches(/^\d{6}$/, { message: "Индекс: 6 цифр" })
  postalCode: string = "";
}

export class LegalStep3Dto {
  @IsNotEmpty({ message: "Укажите фамилию" })
  directorLastName: string = "";

  @IsNotEmpty({ message: "Укажите имя" })
  directorFirstName: string = "";

  @ValidateIf((o) => !!o.directorPhone?.trim())
  @Matches(/^\+\d{11,12}$/, {
    message: "Телефон: +7XXXXXXXXXX (11–12 цифр без пробелов)",
  })
  directorPhone: string = "";
}

export class LegalStep4Dto {
  @IsNotEmpty({ message: "Укажите название банка" })
  bankName: string = "";

  @IsNotEmpty({ message: "Укажите БИК" })
  @Matches(/^\d{9}$/, { message: "БИК: 9 цифр" })
  bik: string = "";

  @IsNotEmpty({ message: "Укажите корр. счёт" })
  @Matches(/^\d{20}$/, { message: "Корр. счёт: 20 цифр" })
  corrAccount: string = "";

  @IsNotEmpty({ message: "Укажите расчётный счёт" })
  @Matches(/^\d{20}$/, { message: "Расч. счёт: 20 цифр" })
  settlementAccount: string = "";
}

export class SelfEmployedDto {
  @IsNotEmpty({ message: "Укажите ФИО" })
  selfFullName: string = "";

  @IsNotEmpty({ message: "Укажите ИНН" })
  @Matches(/^\d{12}$/, { message: "ИНН физлица: 12 цифр" })
  selfInn: string = "";

  @ValidateIf((o) => !!o.selfPhone?.trim())
  @Matches(/^\+\d{11,12}$/, {
    message: "Телефон: +7XXXXXXXXXX (11–12 цифр без пробелов)",
  })
  selfPhone: string = "";

  @ValidateIf((o) => !!o.selfPassportSeries?.trim())
  @Matches(/^\d{4}$/, { message: "Серия: 4 цифры" })
  selfPassportSeries: string = "";

  @ValidateIf((o) => !!o.selfPassportNumber?.trim())
  @Matches(/^\d{6}$/, { message: "Номер: 6 цифр" })
  selfPassportNumber: string = "";
}
